import { Title } from '@atom/typography/typography';

import { DeleteConsumer } from './delete-consumer/delete-consumer';

interface ConsumerSettingsProps {
  id: string;
}

export const ConsumerSettings = ({ id }: ConsumerSettingsProps) => (
  <>
    <Title level={3} mb={16} weight={400}>
      Settings
    </Title>
    <DeleteConsumer id={id} />
  </>
);
